var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-title header-title-text title-notab"},[_c('v-row',{staticClass:"ma-0 mt-2 d-flex"},[_c('span',{staticClass:"ml-2"},[_vm._v("จัดการอนุมัติการเข้าร่วม")]),_c('v-spacer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }